import { FunctionComponent } from 'react'

import { SimpleContainerBox } from '../../../base/components/Container/SimpleBox'
import Breadcrumb from '../../../base/components/Template/Breadcrumb/Breadcrumb'
import ArticuloMonedaLocal from '../../ArticuloMoneda/view/listado/ArticuloMonedaLocal'
import { kardexPeriodoRoutesMap } from '../kardexPeriodoRoutes'
import KardexPeriodoListado from './listado/KardexPeriodoActivoListado'
import { Grid } from '@mui/material'

interface OwnProps {}

type Props = OwnProps

/**
 * Iniciamos las operaciones y seleccionamos la moneda principal
 * @param props
 * @constructor
 */
const KardexPeriodoGestion: FunctionComponent<Props> = (props) => {
  return (
    <SimpleContainerBox maxWidth={'lg'}>
      <Breadcrumb routeSegments={[kardexPeriodoRoutesMap.gestion]} />

      <Grid container spacing={2}>
        <Grid size={6}>
          <KardexPeriodoListado />
        </Grid>
        <Grid size={6}>
          <ArticuloMonedaLocal />
        </Grid>
      </Grid>
    </SimpleContainerBox>
  )
}

export default KardexPeriodoGestion
